import React from 'react'
import _ from 'lodash'
import { Link } from 'react-router-dom'
import { useMutation } from '@apollo/react-hooks'
import {
  message, Menu, Dropdown, Icon, Button,
} from 'antd'
import { SmallText, Div, Button as KonsysButton } from 'konsys-ui'
import history from '../../history'
import { theme } from '../../styles/_variables'
import { P } from '../../pages/start-point-page/styled'
import PERMISSION from '../../constants/permissions'
import { SENDERLOCATION_CREATE_IN_THAIGPS } from '../../constants/graphql/mutation'

const { color } = theme

export const CellText = props => (
  <P font='sarabun' padding='3px' {...props}>{props.children}</P>
)

export const HeaderLabel = props => (
  <SmallText bold color={color.coolGrey} font='sarabun' style={{ fontWeight: 700 }}>{props.children}</SmallText>
)

export const InputWithPlaceHolder = ({ handleChange }) => (
  <input placeholder='ค้นหา' onChange={e => handleChange(e.target.value)}/>
)

const menu = (props) => {
  const [doSyncThaiGPS, { loading }] = useMutation(SENDERLOCATION_CREATE_IN_THAIGPS)
  return (
  <Div>
    <Menu>
      <Menu.Item key='view' disabled={!_.includes(window.perms, PERMISSION.VIEW_STARTPOINT)}>
        <Link target="_blank" to={`/start-point/view/${props?.original?.id}`}>
          ดูรายละเอียด
        </Link>
      </Menu.Item>
      <Menu.Item key='edit' disabled={!_.includes(window.perms, PERMISSION.UPDATE_STARTPOINT)}>
        <Link target="_blank" to={`/start-point/edit/${props?.original?.id}`}>
          แก้ไข
        </Link>
      </Menu.Item>
      {
        _.isNull(props?.original?.thaiGPSId)
        && <Menu.Item
          key='thaiGPSId'
          disabled={!_.includes(window.perms, PERMISSION.UPDATE_STARTPOINT) || loading}
          onClick={() => doSyncThaiGPS({
            variables: {
              id: props?.original?.id,
            },
            refetchQueries: ['SenderLocationList'],
          }).then((res) => {
            if (res?.data?.SenderLocationCreatePOI?.success) {
              message.success(res?.data?.SenderLocationCreatePOI?.message)
            } else message.error(res?.data?.SenderLocationCreatePOI?.message)
          })}>
          สร้างใน thaiGPS
        </Menu.Item>
      }
    </Menu>
  </Div>
  )
}

export const ActionSelector = ({ props }) => (
  <Dropdown overlay={menu(props)} trigger='click'>
    <Button>
      ดูรายละเอียด <Icon type="down" />
    </Button>
  </Dropdown>
)

export const Wrapper = props => (
  <Div
    display='block'
    width='100%'
    flexDirection='row'
    padding={props.padding || '40px 0'}
    justifyContent={props.center && 'center'}
    alignItems='flex-end'
    style={{ borderBottom: `1px solid ${color.paleGrey}`, overflow: props.overflow && 'auto' }}
  >
    {props.children}
  </Div>
)

export const ActionBar = ({
  loading, isAddMode, isViewMode, doAction, mutationVariables, props, disabled,
}) => (
  <Div
    position='fixed'
    height='72px'
    bottom='0'
    left='0'
    right='0'
    style={{ background: `${color.primaryColor}33` }}
    display='flex'
    justifyContent='flex-end'
    alignItems='center'
    padding='0 32px 0 0'
  >
    <KonsysButton
      loading={loading}
      disabled={loading || (isViewMode && !_.includes(window.perms, PERMISSION.UPDATE_STARTPOINT)) || disabled}
      text={isAddMode ? 'สร้างใหม่' : isViewMode ? 'แก้ไข' : 'บันทึก'}
      icon={isAddMode ? 'fas fa-plus' : isViewMode ? 'fas fa-edit' : 'fas fa-save'}
      inverse
      onClick={() => {
        if (isViewMode) history.push(`/start-point/edit/${props.match.params.id}`)
        else {
          doAction({
            variables: isAddMode ? { ...mutationVariables } : { id: parseInt(props.match.params.id, 10), ...mutationVariables },
          }).then(({ data }) => {
            const resp = isAddMode ? data.CreateSenderLocation : data.UpdateSenderLocation

            if (resp.success) {
              message.success(resp.message)

              if (isAddMode) history.push('/start-point')
              // else history.push(`/start-point/view/${props.match.params.id}`)
            } else message.error(resp.message)
          })
        }
      }}
    />
  </Div>
)
